import ComponentManager from '@/Management/ComponentManager';
import UIListener from '@/UIListener/UIListener';
import DetailViewContext from '@/ViewModels/Contexts/DetailViewContext';
import LDAPSearchDialogFactory from '@/Factories/ControlFactories/LDAPSearchDialogFactory';
import MetadataGroupFactory from '@/Components/MetadataGroup/MetadataGroupFactory';
import GlobalConfiguration from '@/Management/GlobalConfiguration';
import ControlFactory from '@/Factories/ControlFactory';
import RADEnvironmentProxy from '@/Communication/RADEnvironmentProxy';
import Loader from '@/Utility/Loader';
import LDAPUsersViewModel from '@/ViewModels/Controls/LDAPUsersViewModel';
import ToolbarHelper from '@/Utility/ToolbarHelper';
import GroupFactory from "@/Factories/GroupFactory";


export default class RADLdapImportUIListener extends UIListener {

    constructor() {
        super();
    }

    public onBeforeRender(context: DetailViewContext) {
        MetadataGroupFactory.hideMetadataAndShowChangelogs(context);
    }

    public onDetailViewReady(context: DetailViewContext): void {
        this.hideEmptyProperties(context);
        this.setupButtons(context);
    }

    private setupButtons(context: DetailViewContext) {
        ToolbarHelper.removeSaveButton(context.toolBar, false);
        ToolbarHelper.removeApplyButton(context.toolBar);

        const ldapSearchViewModel = context.getUIFactory<LDAPSearchDialogFactory>('SearchPlaceHolder')?.viewModel;
        if (ldapSearchViewModel == null)
            return;

        const icon = GlobalConfiguration.inlineImages.LDAP_USER_IMPORT;
        const isLimited = context.genericObject.getValue<boolean>('IsLimited');
        if (isLimited) {
            context.toolBar.addPrimaryElement({
                position: 0,
                locator: 'startNamedUsersImport',
                ergName: ldapSearchViewModel.importNamedUsersText,
                iconUrl: icon,
                isEnabled: true,
                tooltipErgName: ldapSearchViewModel.importNamedUsersTooltip,
                onClick: () => {
                    ldapSearchViewModel.import('named');
                }
            });
            if (context.genericObject.getValue<boolean>('IsLightUserActivated')) {
                context.toolBar.addPrimaryElement({
                    position: 1,
                    locator: 'startLightUsersImport',
                    ergName: ldapSearchViewModel.importLightUsersText,
                    iconUrl: icon,
                    isEnabled: true,
                    tooltipErgName: ldapSearchViewModel.importLightUsersTooltip,
                    onClick: () => {
                        ldapSearchViewModel.import('light');
                    }
                });
            }
        } else {
            const licenseInformationFactory = context.getUIFactory<GroupFactory>('LicenseInformation');
            licenseInformationFactory?.isVisible(false);

            context.toolBar.addPrimaryElement({
                position: 0,
                locator: 'startImport',
                ergName: ldapSearchViewModel.importText,
                iconUrl: icon,
                isEnabled: true,
                tooltipErgName: ldapSearchViewModel.importLightUsersTooltip,
                onClick: () => {
                    ldapSearchViewModel.import();
                }
            });
        }
    }

    private hideEmptyProperties(context: DetailViewContext) {
        Loader.getInstance().show();

        RADEnvironmentProxy.getInstance().callStaticOperation({
            pdTypeName: 'RAD.RADFoundation.ProblemDomain.LDAP.RADLdapImport',
            operationName: 'GetEmptyProperties',
            operationParameters: [],
            contextParameters: {}
        }).then((operationResultDto) => {
            if (!this.validateStatus(operationResultDto))
                return;

            const returnValue = JSON.parse(operationResultDto.returnValue) as string[];
            var ldapUsersViewModel = context.getUIFactory<ControlFactory>('LDAPUsers').viewModel as LDAPUsersViewModel;
            const columnNames = ldapUsersViewModel.grid.columnDefinition().map(x => x.name)

            for (var i = 0; i < returnValue?.length; i++) {
                const emptyProperty = returnValue[i];
                context.getUIFactory<ControlFactory>(emptyProperty)?.isVisible(false);

                var indexEmptyColumn = columnNames.indexOf(this.FirstLetterLowCase(emptyProperty));
                ldapUsersViewModel.grid.columnDefinition()[indexEmptyColumn].isVisible = false;
            }

            ldapUsersViewModel.grid.columnDefinition.notifySubscribers(ldapUsersViewModel.grid.columnDefinition());
            Loader.getInstance().hide();
        });
    }

    private FirstLetterLowCase(word: string): string {
        return word.charAt(0).toLowerCase() + word.slice(1)
    }
}

ComponentManager.setUIListener('RADLdapImportUIListener', RADLdapImportUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setUIListener('RADPresentation.DefaultViewExtensions.UIListener.RADLdapImportUIListener', RADLdapImportUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');